import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import addappMg from "./components/addappMg";
import { googleAdvManageData, googleAdvManageDel } from "@/api/financial/consumptionDetails";
import { tabulation } from "@/mixins/index";
export default {
  name: "tokenMg",
  mixins: [tabulation],
  components: {
    addappMg: addappMg
  },
  data: function data() {
    return {
      tableData: [],
      reqLoading: false,
      total: 0
    };
  },
  activated: function activated() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    searchClick: function searchClick(e) {
      var _this = this;

      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      // if (!this.searchData.special_product_id.toString() && type) {
      //   this.$message.error('请选择产品')
      //   return
      // } else if (!this.searchData.special_product_id.toString() && !type) {
      //   return
      // }
      if (!this.searchData.special_product_id.toString()) {
        this.searchData.special_product_id_all = this.productsListAll.map(function (i) {
          return i.id;
        });
      } else {
        this.searchData.special_product_id_all = this.searchData.special_product_id;
      }

      this.searchData.page = e;
      this.reqLoading = true;
      googleAdvManageData(this.searchData).then(function (res) {
        if (res.status == 200) {
          _this.tableData = res.data.data;
          _this.total = res.data.total;
        }
      }).finally(function () {
        _this.reqLoading = false;
      });
    },
    handleDelete: function handleDelete(ids) {
      var _this2 = this;

      // let id = ids.toString()
      this.$confirm("此操作将删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                googleAdvManageDel({
                  id: ids.toString()
                }).then(function (res) {
                  if (res.status == 200) {
                    _this2.searchClick();

                    _this2.$message({
                      type: "success",
                      message: "删除成功!"
                    });
                  }
                });

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      })));
    }
  }
};